const carouselExtras = {
  props: {
    dynamicClass: ".c-carousel-with-extras.dynamicLoading",
    compSelector: ".c-carousel-extras-swiper",
    cssSelector: "JS-carousel-extras-swiper",
    cssSelectorSwiper: ".swiper-wrapper[data-items-load]",
    nameAttr: "data-items-load",
    config: {
      slidesPerView: 1,
      spaceBetween: 0,
      loopedSlides: 1,
      loop: false,
      grabCursor: true,
      wrapperClass: "swiper-wrapper",
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
    tabsTitlesSelector: ".Js-carousel-extras-tabtitle",
    tabsContainerSelector: ".JS-carousel-extras-container",
    active: "active",
    hidden: "hidden",
  },
  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-carouselExtras.css", this.props.dynamicClass);

    bcl.u.swiper.init(document, this.props);
  },
};

export default carouselExtras;
